import { getLanguagePrefix } from "../../utils/languageUtils";

const getHomePath = () => {
  const prefix = getLanguagePrefix(window.location.pathname);
  return prefix || '/';
};

/**
 * Generate header navigation data with translation function
 * This function creates the header menu structure using i18n translations
 */
export const generateHeaderData = (t, getLocalizedPath) => [
  {
    id: "sluzby-menu-item",
    title: t('nav.services'),
    link: getLocalizedPath("/#services"),
    className: "menu-item-link",
    megamenuClassName: "services-megamenu",
    onClick: () => {
      const sectionId = "services";
      const currentPath = window.location.pathname;
      const homePath = getHomePath();

      if (currentPath !== homePath && currentPath !== homePath + '/') {
        sessionStorage.setItem("scrollToSection", sectionId);
        window.location.href = homePath;
        return;
      }
      const element = document.getElementById(sectionId);
      element?.scrollIntoView({ behavior: "smooth" });
    },
    megamenu: [
      {
        title: t('nav.expertise'),
        dropdown: [
          { title: t('nav.contentStrategy'), isClickable: false },
          { title: t('nav.performanceAnalytics'), isClickable: false },
          { title: t('nav.brandCommunication'), isClickable: false },
          { title: t('nav.aiAutomation'), isClickable: false },
          { title: t('nav.leadGeneration'), isClickable: false },
          { title: t('nav.retailCreative'), isClickable: false },
        ],
      },
      {
        title: t('nav.specialization'),
        dropdown: [
          {
            title: t('nav.wholesale'),
            link: getLocalizedPath("/#services"),
            hoverImage: "/assets/img/webp/velkoobchod.webp",
          },
          {
            title: t('nav.otcMedication'),
            link: getLocalizedPath("/#services"),
            hoverImage: "/assets/img/webp/otc-lieciva.webp",
          },
          {
            title: t('nav.construction'),
            link: getLocalizedPath("/marketing-pre-stavebnictvo"),
            hoverImage: "/assets/img/webp/stavebnictvo.webp",
          },
          {
            title: t('nav.floorStudios'),
            link: getLocalizedPath("/marketing-pre-podlahy"),
            hoverImage: "/assets/img/webp/podlahove-studia.webp",
            onClick: () => {
              window.open(getLocalizedPath("/marketing-pre-podlahy"), "_blank");
            },
          },
          {
            title: t('nav.marketEntry'),
            link: getLocalizedPath("/#services"),
            hoverImage: "/assets/img/webp/market-entry.webp",
          },
          {
            title: t('nav.yourSegment'),
            link: "#",
            modalAction: "openContactModal",
            hoverImage: "/assets/img/webp/vas-segment.webp",
          },
        ],
        defaultImage: "/assets/img/webp/default-specialty.webp",
      },
    ],
  },
  {
    id: "ai-offer-menu-item",
    title: t('nav.aiOffer'),
    link: "https://ai.inaq.sk",
    external: true,
    className: "menu-item-link",
  },
  {
    id: "blog-menu-item",
    title: t('nav.blog'),
    link: getLocalizedPath("/blog"),
    className: "menu-item-link",
  },
  {
    id: "pricelist-menu-item",
    title: t('nav.pricelist'),
    link: getLocalizedPath("/#pricelist"),
    className: "menu-item-link",
    onClick: () => {
      const sectionId = "pricelist";
      const currentPath = window.location.pathname;
      const homePath = getHomePath();

      if (currentPath !== homePath && currentPath !== homePath + '/') {
        sessionStorage.setItem("scrollToSection", sectionId);
        window.location.href = homePath;
        return;
      }
      const element = document.getElementById(sectionId);
      element?.scrollIntoView({ behavior: "smooth" });
    },
  },
  {
    id: "kariera-menu-item",
    className: "menu-item-link",
    title: t('nav.career'),
    notification: {
      count: 1,
      animate: true,
    },
    link: getLocalizedPath("/#careers"),
    onClick: () => {
      const sectionId = "careers";
      const currentPath = window.location.pathname;
      const homePath = getHomePath();

      if (currentPath !== homePath && currentPath !== homePath + '/') {
        sessionStorage.setItem("scrollToSection", sectionId);
        window.location.href = homePath;
        return;
      }
      const element = document.getElementById(sectionId);
      element?.scrollIntoView({ behavior: "smooth" });
    },
  },
  {
    id: "newsletter-menu-item",
    title: t('nav.newsletter'),
    className: "menu-item-link",
    link: getLocalizedPath("/#newsletter"),
    onClick: () => {
      const sectionId = "newsletter";
      const currentPath = window.location.pathname;
      const homePath = getHomePath();

      if (currentPath !== homePath && currentPath !== homePath + '/') {
        sessionStorage.setItem("scrollToSection", sectionId);
        window.location.href = homePath;
        return;
      }
      const element = document.getElementById(sectionId);
      element?.scrollIntoView({ behavior: "smooth" });
    },
    megamenu: [
      {
        title: t('nav.newsletterTitle'),
        dropdown: [
          {
            title: t('nav.newsletterPromo'),
            link: getLocalizedPath("/#newsletter"),
            scrollTo: "newsletter",
          },
        ],
      },
      {
        dropdown: [
          {
            link: getLocalizedPath("/#newsletter"),
            img: "/assets/img/webp/b2b2_newsletter_promo.webp",
            alt: "B2B² newsletter",
            scrollTo: "newsletter",
            onClick: () => {
              const sectionId = "newsletter";
              const currentPath = window.location.pathname;
              const homePath = getHomePath();

              if (currentPath !== homePath && currentPath !== homePath + '/') {
                sessionStorage.setItem("scrollToSection", sectionId);
                window.location.href = homePath;
                return;
              }
              const element = document.getElementById(sectionId);
              element?.scrollIntoView({ behavior: "smooth" });
            },
            className: "newsletter-image-link",
          },
        ],
      },
    ],
  },
  {
    id: "contact-menu-item",
    title: t('nav.contact'),
    className: "menu-item-link",
    link: getLocalizedPath("/#contact"),
    onClick: () => {
      const sectionId = "contact";
      const currentPath = window.location.pathname;
      const homePath = getHomePath();

      if (currentPath !== homePath && currentPath !== homePath + '/') {
        sessionStorage.setItem("scrollToSection", sectionId);
        window.location.href = homePath;
        return;
      }
      const element = document.getElementById(sectionId);
      element?.scrollIntoView({ behavior: "smooth" });
    },
  },
];
